import { createApp, computed } from 'vue'
import { createPinia } from 'pinia'
import { useShippingReportStore } from '@/src/stores/shippingReport.store'

import BaseAlert from '@/src/vueComponent/BaseAlert.vue'
import PartnerShippingReportSearch from '@/src/javascripts/partner/shipping_reports/PartnerShippingReportSearch.vue'

$(document).on('turbo:load turbo:render', () => {
  const supplierShippingReportIndex = document.querySelector('#supplier-shipping-report-index')
  if (supplierShippingReportIndex && !supplierShippingReportIndex.__vue_app__) {
    const pinia = createPinia()
    const app = createApp({
      components: { BaseAlert, PartnerShippingReportSearch },
      setup () {
        const shippingReportStore = useShippingReportStore()
        const showtip = computed(() => shippingReportStore.showtip)
        return { showtip }
      }
    })

    app.use(pinia)
    app.mount(supplierShippingReportIndex)
  }
})
